import {_, React, observer, computed, action, classNames, Fragment, useEffect} from '@api'
import {Icon} from '@blueprintjs/core'
import {KeyboardArrowRight} from '@material-ui/icons'
import {DefaultCatalogContextMenuItems, DetailsNavItem, IContextMenuItems, StoresInstanceContext, useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import {useFlexLayoutInlineCatalogItemDetailsPaneStore} from '@stores/catalog/flexLayout'
import {PrimaryIconButton} from 'centric-ui-components'
import * as css from './DetailsModalNavToolbar.css'

/// region Store

export class DetailsModalNavToolbarStore extends VipLocalStore implements IContextMenuItems {
  constructor(stores: StoresInstance) {
    super(stores)
  }

  get detailsSidebar() {
    return this.stores.sidebar.right
  }

  @computed get details() {
    return this.detailsSidebar.details
  }

  @action onContextMenu = (e: React.MouseEvent) => {
    const {contextMenu} = this
    contextMenu.onComponentContextMenu(e, this)
  }

  @computed get contextMenuItems() {
    return <DetailsModalNavToolbarStoreContext.Provider value={this}>
      <StoresInstanceContext.Provider value={this.stores}>
        <DefaultCatalogContextMenuItems/>
      </StoresInstanceContext.Provider>
    </DetailsModalNavToolbarStoreContext.Provider>
  }

}

export const DetailsModalNavToolbarStoreContext = React.createContext<DetailsModalNavToolbarStore>(null)
export const useDetailsModalNavToolbarStore = () => React.useContext(DetailsModalNavToolbarStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const DetailsModalNavToolbar = observer<MyProps>(function DetailsModalNavToolbar({className, ...props}) {
  const store = useVipLocalStore((stores) => new DetailsModalNavToolbarStore(stores)),
    {detailsSidebar, detailsSidebar: {path}} = store,
    size = _.size(path)

  // useEffect(() => {
  //   console.log(`Mount DetailsModalNavToolbar`)
  //   return () => console.log(`Unmount DetailsModalNavToolbar`)
  // }, [])

  return (
    <DetailsModalNavToolbarStoreContext.Provider value={store}>
      {_.size(path) == 0 ? <div data-no-nav={true}/> :
       <div className={classNames(css.root, className)}
            data-visible={size > 1}
            data-items={size}
            data-grid-area='nav'
         //onContextMenu={onContextMenu}
       >

         <div className={css.navButtons}>
           {path.map((p, i) =>
             <Fragment key={i}>
               <DetailsNavItem item={p} index={i} key={i}/>
             </Fragment>)}
         </div>
         <div className={css.right}>
         <PrimaryIconButton tooltipClassName={css.expandIcon}
                            onClick={() => {detailsSidebar.headerExpanded = !detailsSidebar.headerExpanded}}
                            tooltip={detailsSidebar.headerExpanded ? 'Collapse' : 'Expand'}
                            icon={<Icon icon={!detailsSidebar.headerExpanded ? 'chevron-down' : 'chevron-up'}/>}/>
         </div>
       </div>}
    </DetailsModalNavToolbarStoreContext.Provider>)
})

/// endregion






// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/Modal/DetailsNavToolbar/DetailsModalNavToolbar.tsx